import { safetyTips } from '@/mocks/home';

export default function SafetySection() {
  return (
    <section id="safety" className="w-full bg-secondary-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.3fr] gap-10 lg:gap-16">
          <div className="w-full lg:sticky lg:top-24 lg:h-fit">
            <span className="text-xs md:text-sm font-semibold uppercase tracking-widest text-secondary-700">
              Safety First
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              安全提示：先辨别，再使用
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              寻找入口的过程中，最需要提防的是仿冒页面与来源不明的安装包。
              下面几条是判断时最实用的参考信号，遇到可疑情况时可以先对照一遍。
            </p>

            <div className="mt-6 flex items-start gap-3 rounded-lg border border-secondary-200 bg-background-50 p-4 md:p-5">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-question-answer-line text-lg"></i>
              </span>
              <p className="text-sm leading-relaxed text-foreground-700">
                记住一个判断顺序：先看来源是否官方，再看域名是否规范，最后才看内容是否齐全。
                顺序颠倒最容易踩坑。
              </p>
            </div>
          </div>

          <ul className="flex flex-col gap-4">
            {safetyTips.map((tip) => (
              <li
                key={tip.title}
                className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${tip.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                    {tip.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{tip.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}